import type { AlignMent, Field, RecordPoint } from '@lighthouse/core'
import React from 'react'
import styled, { css } from 'styled-components'

import { alignMap, directionMap } from '../../constant'
import { RelationNormalTag } from './RelationNormalTag'

interface RelationTagPreviewProps {
    value?: string[]
    dsId: string
    relativeField: Field | undefined // 新增：关联字段指针
    relativeShowField: Field | undefined // 新增：关联显示字段指针
    recordPoints: RecordPoint[]
    direction?: 'vertical' | 'horizontal'
    align?: AlignMent
    isMultiple?: boolean
    disabled?: boolean
    onChange: (v: string[]) => void
}

const SCxGroup = styled.div<Pick<React.CSSProperties, 'flexDirection' | 'alignItems'>>`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    ${({ flexDirection, alignItems }) =>
        flexDirection === 'row'
            ? css`
                  flex-direction: row;
                  justify-content: ${alignItems};
              `
            : css`
                  flex-direction: column;
                  align-items: ${alignItems};
              `}
`
export const RelationTagPreview: React.FunctionComponent<RelationTagPreviewProps> = ({
    value = [],
    dsId,
    relativeField,
    relativeShowField,
    recordPoints,
    direction = 'horizontal',
    align = 'left',
    isMultiple,
    disabled,
    onChange
}) => {
    return (
        <SCxGroup flexDirection={directionMap[direction]} alignItems={alignMap[align]}>
            {recordPoints?.map(recordPoint => {
                const isActive = value?.includes(recordPoint.id)
                return (
                    <RelationNormalTag
                        source="tag"
                        key={recordPoint.id}
                        recordId={recordPoint.id}
                        dsId={dsId}
                        relativeField={relativeField}
                        relativeShowField={relativeShowField}
                        isActive={isActive}
                        enableDelete={false}
                        disabled={disabled || recordPoint.disabled}
                        onClick={() => {
                            if (isMultiple) {
                                onChange(isActive ? value?.filter(v => v !== recordPoint.id) : [...value, recordPoint.id])
                            } else {
                                onChange(isActive ? [] : [recordPoint.id])
                            }
                        }}
                    />
                )
            })}
        </SCxGroup>
    )
}
